import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalService } from '../../common/services/global.service';
declare var window:any;

@Component({
  selector: 'interview-wrapper',
  imports: [ CommonModule, TranslateModule ],
  templateUrl: './interview-wrapper.component.html'
})

export class InterviewWrapperComponent implements OnInit {
    @Input() title: string = '';
    @Input() truncateTitle: boolean = false;
    usertype: any;
  
    constructor(public globalService: GlobalService) {}

    ngOnInit(): void {
        window.parent.USER_TYPE = sessionStorage.getItem('usertype');
        this.usertype = window.parent.USER_TYPE;
    }
  
    close(): void {
        this.globalService.backToInterviewList();
    }
}